const formatCountryCodeAndMobile = (countryCode: string, mobile: string) => {
  const formattedCountryCode = countryCode ? countryCode.replace(/\s/g, '') : ''
  const formattedMobile = mobile ? mobile.replace(/\s/g, '') : ''

  return `${formattedCountryCode}${formattedMobile}`
}

export default formatCountryCodeAndMobile
